document.addEventListener('DOMContentLoaded', function () {

  const LIVE_DOMAIN = 'https://sunhorseenergy.com';

  function fixShopLinks() {

    // Fix ALL anchor tags
    document.querySelectorAll('a[href]').forEach(link => {

      try {
        const url = new URL(link.href);

        // Target only /collections/shop links
        if (url.pathname.startsWith('/collections/shop')) {

          // Rewrite domain
          link.href = LIVE_DOMAIN + url.pathname;

          // Force same tab
          link.target = '_self';
          link.rel = 'noopener';

        }
      } catch (e) {
        // Ignore invalid URLs
      }

    });

  }

  // Run multiple times (Cafe theme loads late)
  fixShopLinks();
  setTimeout(fixShopLinks, 500);
  setTimeout(fixShopLinks, 1500);
  setTimeout(fixShopLinks, 3000);

});
